export default __webpack_public_path__ + "static/media/bgno.88963029.jpg";